// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Z6H3Z","content":"Spinner_content__38-3P"};